export default {
  title: {
    id: 'recommendation_cross_sell_title',
    defaultMessage: 'Plays nice with',
  },
  clearedTitle: {
    id: 'recommendation_cross_sell_cleared_title',
    defaultMessage: 'Plop! It all went into your cart.',
  },
  clearedBody: {
    id: 'recommendation_cross_sell_cleared_body',
    defaultMessage:
      'And you know what that means — you’re helping prevent a pretty good amount of carbon emissions, e-waste, and other things.',
  },
  titleAccessories: {
    id: 'recommendation_cross_sell_accessories_title',
    defaultMessage: 'Make it last (even longer)',
  },
}
